import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Legal.css';
import SEO from '../components/SEO';

const Terms = () => {
  return (
    <div className="legal-page">
      <SEO
        title="Terms of Service"
        description="CADENCE Medical Consulting Terms of Service. Service scope, limitations, medication safety rule, and your responsibilities as a client."
        path="/terms"
      />
      <div className="container">
        <div className="legal-content">
          <h1 className="heading-hero">Terms of Service</h1>
          <p className="legal-updated">Last Updated: January 2025</p>

          <section className="legal-section">
            <h2 className="heading-2">1. Acceptance of Terms</h2>
            <p className="body-large">
              By accessing this website and purchasing services, you agree to these Terms of Service and our{' '}
              <Link to="/privacy" style={{ color: 'var(--gold)', textDecoration: 'underline' }}>Refund & Cancellation Policy</Link>, which is incorporated herein by reference.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">2. Services Description</h2>
            <p className="body-large">
              CADENCE Medical Consulting, LLC provides patient advocacy, healthcare navigation, medical record review, and diagnostic consultation services. Our licensed nurse practitioners may provide diagnostic clarification, confirm or identify potential diagnoses based on your medical records and reported symptoms, and offer guidance to support your care with your primary care providers.
            </p>
            <div className="legal-emphasis">
              <p className="body-large">
                <strong>IMPORTANT: Our services include diagnostic consultation but DO NOT include medical treatment, prescriptions, or procedures. We do not replace your treating physicians.</strong> Our role is to empower you with clarity and advocate for your health within the care you receive from your licensed medical providers.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">3. User Responsibilities</h2>
            <p className="body-large">
              You agree to provide accurate information and understand that our guidance relies on the completeness and accuracy of the medical information you provide.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">4. Intellectual Property</h2>
            <p className="body-large">
              All materials provided (reports, plans, scripts) are for your personal use only. You may not reproduce or distribute our proprietary methodologies.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">5. Payment & Refunds</h2>
            <p className="body-large">
              Payment is due at the time of service purchase. Our services involve significant professional time and intellectual labor from the moment you engage us.
            </p>
            <div className="legal-emphasis">
              <p className="body-large">
                <strong>ONCE SERVICES ARE RENDERED (including intake review, consultations, or delivery of any work product), FEES ARE NON-REFUNDABLE.</strong> For complete details, please review our{' '}
                <Link to="/privacy" style={{ color: 'var(--gold)', textDecoration: 'underline' }}>Refund & Cancellation Policy</Link>.
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">6. Cancellation</h2>
            <p className="body-large">
              <strong>For One-Time Services:</strong> Cancellation requests must be submitted before any work has begun. Once services are rendered, fees are non-refundable.
            </p>
            <p className="body-large" style={{ marginTop: '1rem' }}>
              <strong>For Memberships:</strong> You may cancel at any time with written notice. Access continues until the end of your pre-paid term. No prorated refunds for unused portions after services have been utilized. See our{' '}
              <Link to="/privacy" style={{ color: 'var(--gold)', textDecoration: 'underline' }}>Refund & Cancellation Policy</Link> for complete details.
            </p>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">7. Disclaimer & Limitation of Liability</h2>
            <div className="legal-emphasis">
              <p className="body-large">
                <strong>OUR SERVICES ARE PROVIDED "AS IS." TO THE FULLEST EXTENT PERMITTED BY LAW, WE DISCLAIM ALL WARRANTIES. OUR TOTAL LIABILITY FOR ANY CLAIM IS LIMITED TO THE AMOUNT YOU PAID FOR THE SERVICE FROM WHICH THE CLAIM AROSE.</strong>
              </p>
            </div>
          </section>

          <section className="legal-section">
            <h2 className="heading-2">8. Governing Law</h2>
            <p className="body-large">
              These Terms shall be governed by and construed in accordance with the laws of the State of Georgia, without regard to its conflict of law provisions.
            </p>
          </section>

          <section className="legal-section contact-section">
            <h2 className="heading-2">Questions?</h2>
            <p className="body-large">
              If you have any questions about our Terms of Service, please contact us at{' '}
              <a href="mailto:CADENCE@cadencemedicalconsulting.com">CADENCE@cadencemedicalconsulting.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Terms;